<template>
	<div style="padding: 0 10px">
		<ScanQuery @onQuery="queryCall" ph="输入批次包">
			<div slot="customize">
				<el-button
					type="primary"
					@click="openChangeSizeDialog"
					v-if="detail.packageSizeMeasure"
				>
					包装尺寸测量
				</el-button>
				<el-button
					type="primary"
					@click="abnormalClientShow = true"
					:disabled="!detail.pkgCode"
				>
					异常上报客户
				</el-button>
				<el-button
					type="primary"
					@click="abnormalShow = true"
					:disabled="!detail.pkgCode"
				>
					次品登记
				</el-button>
			</div>
		</ScanQuery>
		<el-card style="margin-bottom: 10px">
			<div class="washing__div--card1">
				<ImgView
					:src="productImg"
					:width="311"
					:height="311"
					v-if="productImg"
				/>
				<DescCom
					:desc="desc"
					:column="1"
					border
					fw="600"
					fs="14px"
					v-if="desc"
					style="flex-shrink: 0; flex-grow: 1; margin: 0 20px"
				>
					<template #pkgCode>
						<div style="display: flex; align-items: center">
							<span>{{ detail.pkgCode }}</span>
							<el-tag
								type="danger"
								v-if="detail.orderingOnBehalfOfCustomers === 1"
								style="margin-left: 10px"
								>代客下单</el-tag
							>
							<el-tag
								type="warning"
								effect="dark"
								v-if="detail.allIncludeFlag === 1"
								>一价全包</el-tag
							>
							<el-tag
								type="danger"
								v-if="detail.urgentWarehousing === 1"
								style="margin-left: 10px"
								>加急</el-tag
							>
						</div>
					</template>
					<template #productSku>
						<div style="display: flex; align-items: center">
							<span>{{ detail.productSku }}</span>
							<a
								target="_blank"
								style="margin-left: 5px"
								:href="detail?.productLink"
								>查看商品链接</a
							>
							<a
								v-if="productCode"
								style="margin-left: 5px"
								target="_blank"
								:href="`https://s.theckb.com/ja/goods/${productCode}`"
							>
								CKB链接
							</a>
						</div>
					</template>
					<template #dictateOrderCode>
						<SpecialStock
							:list="specialStorageRequire"
							v-if="detail.id"
							:item="detail"
						/>
					</template>
				</DescCom>
				<div v-if="desc">
					<el-descriptions style="width: 500px; height: 100%" border>
						<el-descriptions-item
							:labelStyle="{ 'font-weight': 600, 'font-size': '14px' }"
							:contentStyle="{ 'font-weight': 600, 'font-size': '14px' }"
						>
							<template slot="label"> 水洗标 </template>
							<div
								style="
									height: 293px;
									display: flex;
									align-items: center;
									justify-content: center;
								"
							>
								<el-button
									:type="!washingLabel ? 'primary' : 'info'"
									:disabled="washingLabel"
									@click="printWashLabel(detail)"
									style="height: 170px; width: 170px"
									>打印水洗标</el-button
								>
							</div>
						</el-descriptions-item>
					</el-descriptions>
				</div>
			</div>
		</el-card>
		<div style="display: flex; justify-content: space-between; width: 100%">
			<el-card style="width: 550px; margin-right: 10px">
				<div slot="header" style="text-align: left">
					<span>附加项</span>
				</div>
				<el-table
					:data="dataSourceFromWms.length ? dataSourceFromWms : dataSource"
					border
					style="width: 100%"
				>
					<el-table-column label="附加项名称" prop="additionName">
					</el-table-column>
					<el-table-column label="辅料名称" prop="ingredientsName">
					</el-table-column>
					<el-table-column label="辅料图片" prop="ingredientsName" width="100">
						<template slot-scope="scope">
              <div style="padding: 10px; height: 80px;">
                <ImgPreviews
                  :images="scope.row.ingredientsImg.split(',')"
                  :width="60"
                  :height="60"
                  v-if="scope.row.ingredientsImg"
                />
                <div
                  v-if="
                    scope.row.ingredientsImg &&
                    scope.row.ingredientsImg.split(',').length > 1
                  "
                >
                  左右切换查看更多图片
                </div>
                <span v-if="!scope.row.ingredientsImg">-</span>
              </div>
						</template>
					</el-table-column>
					<el-table-column label="辅料库位" prop="ingredientsName">
						<template slot-scope="scope">
							{{ scope.row.gridCode }}
						</template>
					</el-table-column>
					<el-table-column label="批次包" prop="pkgCodeList">
						<template slot-scope="scope">
							{{ scope.row.pkgCodeList?.join(',') }}
						</template>
					</el-table-column>
					<el-table-column label="辅料sku" prop="ingredientsSku">
						<template slot-scope="scope">
							{{ scope.row.ingredientsSku }}
						</template>
					</el-table-column>
					<el-table-column label="数量" prop="nums">
						<template slot-scope="scope">
							{{ scope.row.nums }}
						</template>
					</el-table-column>
					<el-table-column label="规格" prop="ingredientProp">
						<template slot-scope="scope">
							{{ scope.row.ingredientProp }}
						</template>
					</el-table-column>
					<el-table-column label="客户统一全名" prop="unificationCustomerFullName">
						<template slot-scope="scope">
							{{ scope.row.unificationCustomerFullName }}
						</template>
					</el-table-column>
				</el-table>
			</el-card>
			<el-card style="width: 550px; margin-right: 10px">
				<div slot="header" style="text-align: left">
					<span>特殊质检要求</span>
				</div>
				<el-table :data="specialCheckRequirement" border>
					<el-table-column label="要求内容" prop="specialCheckRequirement">
					</el-table-column>
					<el-table-column label="图片" prop="ingredientsName">
						<template slot-scope="scope">
							<ImgView
								:src="scope.row.specialCheckRequirementImg"
								:width="100"
								:height="100"
								v-if="scope.row.specialCheckRequirementImg"
							/>
							<span v-if="!scope.row.specialCheckRequirementImg">-</span>
						</template>
					</el-table-column>
				</el-table>
			</el-card>
			<el-card style="width: 550px">
				<div
					slot="header"
					style="
						display: flex;
						align-items: center;
						justify-content: space-between;
					"
				>
					<span>尺寸测量(单位:cm)</span>
					<span style="flex: 1"></span>
					<BatchCopyCode
						:sizeList="sizeList"
						:category="category"
						:productSku="detail.productSku"
						v-if="!(!canChangeSize || !detail.needMeasureFlag)"
						:item="detail"
            :checkSize="checkSize"
					/>
					<el-button
						@click="saveSize"
						type="primary"
						size="small"
						:disabled="!canChangeSize || !detail.needMeasureFlag"
						style="float: right; margin-left: 10px"
						>提交</el-button
					>
				</div>
				<el-tag
					type="danger"
					v-if="isSpecialUser"
					style="white-space: normal; height: auto; margin-bottom: 20px"
					>客户特殊需求对应，尺寸测量请先选择商品分类，并按照参考图说明进行测量项填写</el-tag
				>
				<div class="goods-cate" v-if="isSpecialUser">
					<span>请先选择商品分类：</span>
					<el-select
						v-model="category"
						placeholder="请选择"
						@change="changeSelect"
					>
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select>
					<a @click="openImage" v-if="category !== 'all'">参考图</a>
				</div>
				<el-descriptions
					class="margin-top size-descriptions"
					:column="2"
					size="small"
					border
					:labelStyle="{ flex: 1 }"
					:contentStyle="{ flex: 1 }"
				>
					<el-descriptions-item v-for="i in sizeList" :key="i.code">
						<el-form class="measureForm">
							<el-form-item
								:error="
									!i.value  ? '' : noRuleSizeList.includes(i.name) && !/^[0-9/]+$/.test(i.value) ? '请输入数字和/' :!noRuleSizeList.includes(i.name) && !/^[0-9]+$/.test(i.value) ?  '请输入数字' : ''
								"
							>
								<el-input
									v-model="i.value"
									:disabled="!detail.needMeasureFlag"
								></el-input>
							</el-form-item>
						</el-form>
						<template slot="label">
							{{ i.name }}
						</template>
					</el-descriptions-item>
					<el-descriptions-item
						v-for="i in sizeList.length % 2"
						:key="i"
					></el-descriptions-item>
				</el-descriptions>
			</el-card>
		</div>
		<el-dialog
			title="次品登记"
			:visible.sync="abnormalShow"
			width="1300px"
			destroy-on-close
		>
			<AbnormalContent
				:abnormalOptionList="abnormalDefective"
				checkType="checkbox"
				:record="detail"
				@submit="defectiveCall($event, 2)"
			></AbnormalContent>
		</el-dialog>
		<el-dialog
			title="异常上报客户"
			:visible.sync="abnormalClientShow"
			width="1300px"
			destroy-on-close
		>
			<AbnormalContent
				:abnormalOptionList="customerAbnormalDefective"
				checkType="popBtn"
				:record="detail"
				@submit="defectiveCall($event, 3)"
			></AbnormalContent>
		</el-dialog>
		<el-dialog
			title="参考图"
			:visible.sync="dialogVisible"
			width="800px"
			:footer="null"
		>
			<div><img :src="prewImage" alt="" style="width: 100%" /></div>
		</el-dialog>
		<ChangeSize ref="changeSizeRef" @success="getDetails" />
	</div>
</template>

<script>
import BatchCopyCode from "@/views/inHouse/components/BatchCopySize";
import AbnormalContent from "@/components/AbnormalContent.vue";
import { abnormalDefective, customerAbnormalDefective } from "@/types";
import ScanQuery from "@/components/ScanQuery";
import DescCom from "@/components/DescCom";
import AccessoriesCom from "@/components/AccessoriesCom";
import ImgView from "@/components/ImgView";
import ImgPreviews from "@/components/ImgPreviews";
import { pkgDetail, pkgDetailLog } from "@/apis/abnormal";
import {
	orderRemakeCount,
	getIngredientsBatch,
	getWashedlabelWarehouse,
	byProductSkuList,
	byProductSkuList_OEM,
	selectApiSku,
	getProductMaterial,
	printLabelRecordLog,
	queryCustomerProductMsku,
	editSize,
	getSkuMaterials,
	promptCheck,
	listSpecialInboundRequirement,
} from "@/apis/checking";
import { byProductSku } from "@/apis/inHouse";
import { checkSpecialInboundRequirementCustomer } from "@/apis/inHouse";
import { pkgSplit } from "@/apis/abnormal";
import { washlabelImages, washTemplateJson } from "@/utils/print";
import { print, print2 } from "@/components/PrintTemplate/index.js";
import { sizeList } from "@/views/inHouse/newProductCheck/sizeList.js";
import { getDefaultLabelConfig } from "@/apis/autoPrint";
import { executePrintWashlabel } from "@/utils/printWashlabel";
import sizeMinxin from "@/mixins/sizeMixin.js";
import SpecialStock from "./components/SpecialStock";
import { inHouseDoStockIn } from "@/apis/inHouse";
import ChangeSize from "./components/ChangeSize.vue";
export default {
	name: "QCRequire",
	components: {
		ScanQuery,
		DescCom,
		ImgView,
		AccessoriesCom,
		ImgPreviews,
		AbnormalContent,
		BatchCopyCode,
		SpecialStock,
		ChangeSize,
	},
	mixins: [sizeMinxin],
	data() {
		return {
			customerAbnormalDefective: [
				{
					value: "205",
					title: "尺码差异",
				},
				...customerAbnormalDefective,
			],
			category: "all",
			prewImage: "",
			dialogVisible: false,
			abnormalDefective,
			detail: {},
			specialCheckRequirement: [],
			washingLabel: true,
			imgUri: "",
			query: {
				code: "",
			},
			desc: "",
			specialQC: [], // String
			AdditionalItems: [],
			annex: [],
			productImg: "",
			specialCheckRequirementImgSet: [],
			specialCheckRequirementSet: [],
			abnormalShow: false,
			abnormalClientShow: false,
			ingredientList: [],
			dataSource: [],
			dataSourceFromWms: [],
			isSpecialUser: false,
			productMeasureDtoList: [],
			// 特殊入库要求
			specialStorageRequire: [],
			productCode: "",
		};
	},
	computed: {
		canChangeSize: function () {
			return this.detail?.orderCode && this.sizeList.some((v) => v.value);
		},
    noRuleSizeList: function(){
      const name = this.$store.getters.getWarehouses?.filter(
				(item) => item.wareCode == this.$store.getters.getWareCode
			)[0].wareName;
			return name === "杭州仓" ? ['腰围', '臀围'] : []
      
    }
	},
	methods: {
		queryCall: function (payload) {
			if (payload.code) {
				this.query.code = payload.code;
				(this.specialQC = []), // String
					(this.AdditionalItems = []),
					(this.annex = []),
					(this.productImg = "");
				this.specialCheckRequirementSet = [];
				this.specialCheckRequirementImgSet = [];

				this.dataSource = [];
				(this.dataSourceFromWms = []), (this.specialCheckRequirement = []);
				this.washingLabel = true;
				this.sizes = sizeList.map((v) => {
					return {
						...v,
						value: "",
					};
				});
				this.getDetails();
			}
		},
		getDetails: function () {
			let params = {
				pkgCode: this.query.code,
			};
			pkgDetail(params).then(async ({ code, data }) => {
				if (code === 0) {
					pkgDetailLog(params);
					if (data.productType == 1) {
						const res = await byProductSku({ productSku: data.productSku });
						if (res?.code == 0) {
							this.productCode = res.data?.productCode;
						}
					}
					this.detail = data;
					this.isSpecialUser = data.sizeMeasureCustomerFlag === 1;
					this.category = data.measureCategory || "all";
					this.productMeasureDtoList = data.productMeasureDtoList ?? [];
					this.getSizeList();
					if (data.productMeasureDtoList) {
						this.sizeList = this.sizeList.map((v) => {
							return {
								...v,
								value: this.productMeasureDtoList.filter(
									(y) => y.code == v.code
								).length
									? this.productMeasureDtoList.filter(
											(y) => y.code == v.code
									  )[0].value
									: "",
							};
						});
					}
					if (data.customerId) {
						const res1 = await checkSpecialInboundRequirementCustomer({
							customerId: data.customerId,
						});
						if (res1.data) {
							const res = await listSpecialInboundRequirement({
								systemOrderNos: [data.dictateOrderCode],
							});
							this.specialStorageRequire = res.data ?? [];
							console.log(res.data, "res.data");
						}
					}

					this.productImg = data.productImg;
					this.desc = {
						managerName: {
							title: "复购单经理",
							value: data.managerName,
						},
						marketingManagerName: {
							title: "营销经理",
							value: data.marketingManagerName,
						},
						pkgCode: {
							title: "批次包编码",
							value: data.pkgCode,
							sort: "pkgCode",
						},
						amount: {
							title: "批次数量",
							value: data.amount,
						},
						productProp: {
							title: "颜色尺码",
							value: data.productProp,
						},
						unificationCustomerFullName: {
							title: "客户名称",
							value: data.unificationCustomerFullName || "",
						},
						goodsName: {
							title: "商品名称",
							value: data.productName,
						},
						remark: {
							title: "备注信息",
							value: data.remark,
						},
						goodsType: {
							title: "商品类型",
							value:
								data.combinationProductItemFlag == 1
									? "组合商品子商品"
									: data.productType == 1
									? "普通商品"
									: data.productType == 2
									? "OEM商品"
									: data.productType == 3
									? "组合商品主商品"
									: "-",
						},
						productSku: {
							title: "平台SKU",
							value: data.productSku,
							sort: "productSku",
						},
						dictateOrderCode: {
							title: "特殊入库要求",
							value: data.dictateOrderCode,
							sort: "dictateOrderCode",
						},
					};
					let params_son = {
						systemOrderNo: data.orderCode,
					};
					if (data.specialCheckRequirement) {
						this.specialCheckRequirement = [
							{
								specialCheckRequirement: data.specialCheckRequirement,
								specialCheckRequirementImg: data.specialCheckRequirementImg,
							},
						];
					}
					let recommendedLocation = data.recommendedLocation;
					let additionList = data.additionalList;
					let ingredientsSku = [];
					additionList.forEach((item, index) => {
						item.additionName += item.additionExtraName
							? `:${item.additionExtraName}`
							: "";
						if (item.ingredientsSku) {
							ingredientsSku.push(item.ingredientsSku);
						}
					});
					getIngredientsBatch(ingredientsSku).then((res) => {
						for (let i in additionList) {
							additionList[i].ingredientsSku && res.data
								? (additionList[i].gridCode = res.data.filter(
										(v) => v.ingredientsSku == additionList[i].ingredientsSku
								  )[0].gridCode)
								: "";
						}
						this.dataSource = additionList;
					});
					// getAdditionalItemsInfo(params_son).then(({ code, data }) => {
					//   if (code === 0) {
					//     if (data && data.length) {
					//       let ingredientsSku = []
					//       data.forEach((item, index) => {
					//         item.additionName += item.additionExtraName ? `:${item.additionExtraName}` : ''
					//         if (item.ingredientsSku) {
					//           ingredientsSku.push(item.ingredientsSku)
					//         }
					//       })
					//       // this.dataSource = data
					//       getIngredientsBatch(ingredientsSku).then(res => {
					//         for (let i in data) {
					//           data[i].ingredientsSku && res.data ? data[i].gridCode = res.data.filter(v => v.ingredientsSku == data[i].ingredientsSku)[0].gridCode : ''
					//         }
					//         this.dataSource = data
					//       })
					//     } else {
					//       // this.$message.warning('商品无附加项')
					//     }
					//   }
					// })
					// getAdditionalItems({ pkgCode: data.pkgCode }).then(({ code, data }) => {
					//   if (code == 0) {
					//     if (data && data.length) {
					//       let ingredientsSku = []
					//       data.forEach((item, index) => {
					//         item.additionName += item.additionExtraName ? `:${item.additionExtraName}` : ''
					//         if (item.ingredientsSku) {
					//           ingredientsSku.push(item.ingredientsSku)
					//         }
					//       })
					//       // this.dataSource = data
					//       getIngredientsBatch(ingredientsSku).then(res => {
					//         for (let i in data) {
					//           data[i].ingredientsSku && res.data ? data[i].gridCode = res.data.filter(v => v.ingredientsSku == data[i].ingredientsSku)[0].gridCode : ''
					//         }
					//         this.dataSourceFromWms = data
					//       })
					//     } else {
					//       // this.$message.warning('商品无附加项')
					//     }
					//   }
					// })

					getProductMaterial(params_son).then(({ code, data }) => {
						if (code === 0) {
							if (data && data.length > 0) {
								this.washingLabel = false;
							} else {
								this.washingLabel = true;
							}
						}
					});

					//获取材质
					// let productSkuList = [data.productSku]
					// byProductSkuList(productSkuList).then(res => {
					//   if (res.code != 0 || !res.data || !res.data[0].materialInfoJa) {
					//     this.washingLabel = true
					//   } else {
					//     this.washingLabel = false
					//   }
					// })
				}
			});
		},
		async defectiveCall(val, pkgType) {
			console.log("de", val, pkgType);
			const that = this;
			const { pkgCode } = that.detail;
			console.log(val);
			if (pkgType == 2) {
				const toClient = await orderRemakeCount({ pkgCode });
				if (toClient.data > 0) {
					// if(true){
					that
						.$confirm(
							`此商品已重拍${toClient.data}次，为了降低客户次品率，请选择异常上报客户`,
							"提示",
							{
								confirmButtonText: "前往异常上报客户",
								type: "error",
								cancelButtonText: "继续登记次品",
								distinguishCancelAndClose: true,
							}
						)
						.then(() => {
							that.abnormalShow = false;
							that.abnormalClientShow = true;
						})
						.catch((action) => {
							console.log(action);
							if (action == "cancel") {
								continueSplit();
							}
						});
					return;
				}
				continueSplit();
				return;
			} else {
				const promptCheckFlag = await promptCheck({
					pkgCode,
					exceptionCodeList: val.abnormalTypeList,
					exceptionItemDtoList: val.exceptionItemDtoList,
				});
				if (promptCheckFlag.data.popup == 1) {
					that
						.$confirm(`批次包已上传过此异常情形，是否继续提交`, "提示", {
							confirmButtonText: "确认",
							type: "error",
							cancelButtonText: "取消",
						})
						.then(() => {
							continueSplit();
						});
					return;
				}
				continueSplit();
			}
			function continueSplit() {
				const params = {
					pkgType: pkgType,
					exceptionCodeList: val.abnormalTypeList,
					exceptionItemDtoList: val.exceptionItemDtoList,
					picRelation: val.qrCode,
					pkgCode: pkgCode,
					amount: val.num,
					remark: val.textarea,
				};
				let reg = /^[1-9]+[0-9]*]*$/;
				if (!reg.test(params.amount)) {
					that.$message.error("入库数量格式错误");
					return;
				}
				if (params.amount > that.detail.amount) {
					that.$message.error("异常数量不能大于批次包数量");
					return;
				}
				if (val.textarea.length > 100) {
					that.$message.error("备注超长");
					return;
				}
				pkgSplit(params).then(({ code, data }) => {
					if (code === 0) {
						that.$message.success("成功");
						that.getDetails();
						that.abnormalShow = false;
						that.abnormalClientShow = false;
					}
				});
			}
		},

		async printWashLabel(record) {
			executePrintWashlabel(record);
			return;
			const material = {
				JapanStation: "materialInfoJa",
				KoreaStation: "materialInfoKr",
				UkStation: "materialInfoEn",
			}[record.stationCode];
			console.log(record);
			//获取规格
			let selParams = {
				productSku: record.productSku,
				platformOrderNo: record.platformOrderNo,
				orderCode: record.orderCode,
			};
			let shopProductPropertiesName = await selectApiSku(selParams);
			if (
				!shopProductPropertiesName.data ||
				shopProductPropertiesName.code != 0
			) {
				shopProductPropertiesName.data = {
					shopProductSku: undefined,
					thirdItemAttribute: undefined,
				};
				// this.$message.warning('规格信息缺失，请联系采购')
			}

			//获取logo公司名公司地址
			let params = {
				customerShopId: record.customerShopId,
			};
			let companyinfo = await getWashedlabelWarehouse(params);
			let hascompanyinfo =
				companyinfo.code == 0 &&
				companyinfo.data &&
				companyinfo.data.washedLabelRespDTOList;
			// if (companyinfo.code != 0 || !companyinfo.data || !companyinfo.data.washedLabelRespDTOList) {
			//   this.$message.warning("客户未配置公司信息")
			//   return
			// }

			//获取材质
			let materialInfo;
			materialInfo = await getSkuMaterials({ pkgCode: record.pkgCode });
			if (materialInfo.code != 0) {
				return;
			}
			if (!materialInfo.data) {
				this.$message.warning("材质信息缺失，请联系采购");
				return;
			}
			// if(this.detail.productType == 2){
			//   let params = {
			//     sku: this.detail.productSku,
			//     pageNum: 1,
			//     pageSize: 1
			//   }
			//   materialInfo = await byProductSkuList_OEM(params)
			//   if (materialInfo.code != 0 || !materialInfo.data.records || !materialInfo.data.records[0] || !materialInfo.data.records[0].materials) {
			//     this.$message.warning("材质信息缺失，请联系采购")
			//     return
			//   }
			//   materialInfo = {
			//     data: materialInfo.data.records.map(v=>{
			//       return {
			//         ...v,
			//         materialInfoEn: v.materials,
			//         materialInfoKr: v.materials,
			//         materialInfoJa: v.materials
			//       }
			//     })
			//   }
			// }else{
			//   let productSkuList = [record.productSku]
			//   materialInfo = await byProductSkuList(productSkuList)
			//   if (materialInfo.code != 0 || !materialInfo.data || !materialInfo.data[0] || !materialInfo.data[0][material]) {
			//     this.$message.warning("材质信息缺失，请联系采购")
			//     return
			//   }
			// }

			//获取b2b水洗标shopProductSku
			let b2bShopProductSku = await queryCustomerProductMsku({
				customerShopId: record.customerShopId,
				shopProductSku: record.shopProductSku,
			});

			//打印
			let printdata = [
				{
					...record,
					// ...companyinfo.data.washedLabelRespDTOList[0],
					// ...materialInfo.data[0],
					// ...shopProductPropertiesName,
					shopProductPropertiesName:
						shopProductPropertiesName.data.thirdItemAttribute,
					shopProductSku: shopProductPropertiesName.data.shopProductSku,
					//materialInfoJa 配置的打印模板入参是materialInfoJa，还是按materialInfoJa传过去
					materialInfoJa: materialInfo.data,
					// shopProductPropertiesName: shopProductPropertiesName.data.shopProductPropertiesName
				},
			];
			if (hascompanyinfo) {
				printdata = [
					{
						...companyinfo.data.washedLabelRespDTOList[0],
						...printdata[0],
					},
				];
			}
			//如果存在 添加表头
			if (printdata[0].materialInfoJa) {
				printdata[0].materialInfoJa =
					this.headerTranslate(record.stationCode, "materialInfoJa") +
					printdata[0].materialInfoJa;
			}
			if (printdata[0].shopProductPropertiesName) {
				printdata[0].productPropertiesNameParse =
					this.headerTranslate(
						record.stationCode,
						"productPropertiesNameParse"
					) + printdata[0].shopProductPropertiesName;
			}
			if (
				(record.productDesignation == 3 || record.productDesignation == 2) &&
				record.customerProductSku
			) {
				printdata[0].shopProductSku =
					this.headerTranslate(record.stationCode, "shopProductSku") +
					record.customerProductSku;
			} else {
				printdata[0].shopProductSku = undefined;
			}

			let templateJsonCache = washTemplateJson;
			function templateInt(templateJson) {
				templateJsonCache = JSON.parse(templateJson);
				if (
					hascompanyinfo &&
					companyinfo.data.washedLabelRespDTOList[0].companyLogo
				) {
					let imageRatio =
						companyinfo.data.washedLabelRespDTOList[0].imageRatio;
					let options = {
						options: {
							left: imageRatio == 2 ? 8 : 41,
							top: 200,
							height: 84,
							width: imageRatio == 2 ? 150 : 84,
							src: companyinfo.data.washedLabelRespDTOList[0].companyLogo,
							// src:'https://theckbstest-oss.theckbs.com/transfer/1662448777000封面1.jpg',
						},
						printElementType: {
							title: "图片",
							type: "image",
						},
					};
					if (record.stationCode != "JapanStation") {
						options.options.styler = function () {
							return {
								transform: "rotate(180deg)",
							};
						};
					}
					templateJsonCache.panels[0].printElements.push(
						options,
						...washlabelImages
					);
				} else {
					templateJsonCache.panels[0].printElements.push(...washlabelImages);
				}
				return templateJsonCache;
			}
			this.$loading = true;
			this.$printPkg(
				2,
				this.detail.systemSource,
				[{ ...printdata[0], wantPrintNum: printdata[0].amount }],
				templateInt,
				printdata[0].stationCode,
				record.directSaleFlag
			)
				.catch((res) => {
					getDefaultLabelConfig({
						nodeType: 2,
						systemSource: this.detail.systemSource,
						stationCode: printdata[0].stationCode,
						directSaleFlag: record.directSaleFlag,
					}).then((res) => {
						print2(templateInt(res.data.templateJson), printdata);
						// print2(templateInt(templateJsonCache), printdata);
					});
				})
				.finally(() => {
					this.$loading = false;
				});
			printLabelRecordLog({ pkgCode: this.query.code });
		},
    checkSize(){
        // 腰围, 臀围 随便填
      const sizeList = this.sizeList.filter(v => !this.noRuleSizeList.includes(v.name))
      if (this.sizeList.filter(v => this.noRuleSizeList.includes(v.name) && v.value).some((v) => !/^[0-9/]+$/.test(v.value))) {
				this.$message.warning(this.noRuleSizeList.join('或') + "必须是数字或者/");
				return false;
			}
			if (sizeList.some((v) => isNaN(v.value))) {
				this.$message.warning("尺寸必须是数字");
				return false;
			}
			if (sizeList.some((v) => v.value && Number(v.value) == 0)) {
				this.$message.warning("尺寸不能为0");
				return false;
			}
			if (sizeList.some((v) => v.value && Number(v.value) < 0)) {
				this.$message.warning("尺寸不能为负数");
				return false;
			}
      return true
    },
		saveSize() {
      const isTrue = this.checkSize()
      if(!isTrue) return
			let params = {
				measureCategory: this.category === "all" ? "" : this.category,
				orderCode: this.detail.orderCode,
				list: this.sizeList
					.filter((v) => v.value)
					.map((v) => {
						return {
							...v,
							value: isNaN(v.value) ? v.value : Number(v.value),
						};
					}),
			};
			editSize(params).then((res) => {
				if (res.code == 0) {
					this.$message.success(res.msg);
				}
			});
		},

		headerTranslate(stationCode, str) {
			const data = {
				materialInfoJa: {
					JapanStation: "表地: ",
					KoreaStation: "QUA: ",
					UkStation: "Surface: ",
					default: "Material: ",
				},
				productPropertiesNameParse: {
					JapanStation: "サイズ: ",
					KoreaStation: "SIZE: ",
					UkStation: "Specification: ",
					default: "Specification: ",
				},
				shopProductSku: {
					JapanStation: "お客様SKU: ",
					KoreaStation: "SKU: ",
					UkStation: "Customer SKU: ",
					default: "Customer SKU: ",
				},
			};
			return data[str][stationCode] ?? data[str].default;
		},
		async upToClient() {
			const that = this;
			console.log(that.$refs.Client);
			let children = that.$refs.Client;
			const val = await children.getVal();
			console.log(val);
			const { pkgCode } = that.detail;
			const promptCheckFlag = await promptCheck({
				pkgCode,
				exceptionCodeList: val.abnormal,
			});
			if (promptCheckFlag.data.popup == 1) {
				that
					.$confirm(`批次包已上传过此异常情形，是否继续提交`, "提示", {
						confirmButtonText: "确认",
						type: "error",
						cancelButtonText: "取消",
					})
					.then(() => {
						continueUp();
					});
				return;
			}
			continueUp();
			function continueUp() {
				const params = {
					pkgType: 3,
					exceptionCodeList: val.abnormal,
					picRelation: val.qrCode,
					pkgCode: pkgCode,
					amount: val.abnormalAmount,
					remark: val.textarea,
					exceptionSource: 2,
				};
				if (val.textarea.length > 100) {
					that.$message.error("备注超长");
					return;
				}
				if (params.exceptionCodeList.length == 0) {
					that.$message.error("请勾选异常类型");
					return;
				}
				let reg = /^[1-9]+[0-9]*]*$/;
				if (!reg.test(params.amount)) {
					that.$message.error("入库数量格式错误");
					return;
				}
				if (params.amount > that.detail.amount) {
					that.$message.error("异常数量不能大于批次包数量");
					return;
				}
				pkgSplit(params).then(({ code, data }) => {
					if (code === 0) {
						that.$message.success("成功");
						that.getDetails();
						that.abnormalShow = false;
					}
				});
			}
		},
		openChangeSizeDialog() {
			this.$refs.changeSizeRef.open(this.detail);
		},
	},
	mounted() {},
};
</script>

<style scoped lang="less">
.goods-cate {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin-bottom: 20px;

	a {
		margin-left: 20px;
	}
}

.washing__div--card1 {
	display: flex;
	justify-content: space-between;
}
</style>
<style lang="less">
.measureForm .el-form-item {
	margin-bottom: 0px;
}

.size-descriptions .el-descriptions-row {
	display: flex;

	.el-descriptions-item__cell {
		border-right: 0 !important;
		border-bottom: 0 !important;
		display: flex;
		align-items: center;
	}

	.el-descriptions-item__cell:last-child {
		border-right: 1px solid #ebeef5 !important;
	}
}

.size-descriptions tbody:last-child {
	.el-descriptions-row {
		.el-descriptions-item__cell {
			border-bottom: 1px solid #ebeef5 !important;
		}
	}
}
</style>